import { render, staticRenderFns } from "./ShipmentCard.vue?vue&type=template&id=8ccd128e&scoped=true&"
import script from "./ShipmentCard.vue?vue&type=script&lang=js&"
export * from "./ShipmentCard.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCard.vue?vue&type=style&index=0&id=8ccd128e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccd128e",
  null
  
)

export default component.exports